// extracted by mini-css-extract-plugin
export default {"advWrapper":"Advantages_advWrapper__qbqGp","title":"Advantages_title__HzL3G","points":"Advantages_points__HhRzu","point":"Advantages_point__I8z3V"};